import React from "react";
import { Box, TextField, MenuItem } from "@mui/material";

const SelectCommon = ({
    label = "Status",
    value,
    onChange,
    sx = {},
    options = [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Inactive", value: "inactive" },
        { label: "Deactive", value: "deactive" },
    ],
    ...props
}) => {
    return (
        <Box sx={{ width: 130, ...sx }}>
            <TextField
                fullWidth
                label={label}
                select
                value={value}
                onChange={onChange}
                size="small"
                variant="outlined"
                sx={{
                    "& .MuiOutlinedInput-root": {
                        height: "50px",
                        display: "flex",
                        alignItems: "center",
                    },
                    "& .MuiInputBase-input": {
                        height: "50px",
                        display: "flex",
                        alignItems: "center",
                    },
                    ...sx
                }}
                {...props}
            >
                {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </TextField>
        </Box>
    );
};

export default SelectCommon;
